import {
  APIgetTaxonomies,
  APIgetTerms,
  APIgetCustomFields,
  APIgetMetadataGroups,
} from '../api/Metadata';
import {
  APIgetPageTaxonomies,
  APIgetPageMetadataGroups,
  APIgetPageStatuses,
} from '../api/Pages';
import { getFileStatuses } from './Files';

export const SET_TAXONOMIES_LOADING = 'SET_TAXONOMIES_LOADING';
export const GET_TAXONOMIES = 'GET_TAXONOMIES';
export const GET_TERMS = 'GET_TERMS';
export const SET_METADATA_GROUPS_LOADING = 'SET_METADATA_GROUPS_LOADING';
export const GET_METADATA_GROUPS = 'GET_METADATA_GROUPS';
export const SET_CUSTOM_FIELDS_LOADING = 'SET_CUSTOM_FIELDS_LOADING';
export const SET_CUSTOM_FIELDS = 'SET_CUSTOM_FIELDS';

export const setTaxonomiesLoading = status => ({
  type: SET_TAXONOMIES_LOADING,
  loadingTaxonomies: status,
});

export const getTaxonomies = taxonomies => ({
  type: GET_TAXONOMIES,
  taxonomies,
});

export const getTerms = (taxonomyId, terms) => ({
  type: GET_TERMS,
  taxonomyId,
  terms,
});

export const fetchTaxonomies = params => (dispatch) => {
  dispatch(setTaxonomiesLoading(true));
  return APIgetTaxonomies(params)
    .then((response) => {
      dispatch(getTaxonomies(response.data));
      dispatch(setTaxonomiesLoading(false));
      return response.data;
    })
    .catch(error => (error));
};

export const fetchTerms = taxonomyId => (dispatch) => {
  dispatch(setTaxonomiesLoading(true));
  return APIgetTerms(taxonomyId)
    .then((response) => {
      dispatch(getTerms(taxonomyId, response.data));
      dispatch(setTaxonomiesLoading(false));
      return response.data;
    })
    .catch(error => (error));
};

export const setMetadataGroupsLoading = status => ({
  type: SET_METADATA_GROUPS_LOADING,
  loadingGroups: status,
});

export const getMetadataGroups = metadataGroups => ({
  type: GET_METADATA_GROUPS,
  metadataGroups,
});

export const fetchMetadataGroups = params => (dispatch) => {
  dispatch(setMetadataGroupsLoading(true));
  return APIgetMetadataGroups(params)
    .then((response) => {
      dispatch(getMetadataGroups(response.data));
      dispatch(setMetadataGroupsLoading(false));
      return response.data;
    })
    .catch(error => (error));
};

export const setCustomFieldsLoading = status => ({
  type: SET_CUSTOM_FIELDS_LOADING,
  loadingCustomFields: status,
});

export const setCustomFields = customFields => ({
  type: SET_CUSTOM_FIELDS,
  customFields,
});

export const fetchCustomFields = (params, silent = false) => (dispatch) => {
  if (!silent) {
    dispatch(setCustomFieldsLoading(true));
  }
  return APIgetCustomFields(params)
    .then((response) => {
      dispatch(setCustomFields(response.data));
      if (!silent) {
        dispatch(setCustomFieldsLoading(false));
      }
      return response.data;
    })
    .catch(error => (error));
};

export const fetchPageMetadata = (pageId, options = {}) => dispatch => {
  dispatch(getTaxonomies([]));
  dispatch(getMetadataGroups([]));
  dispatch(getFileStatuses([]));
  dispatch(setTaxonomiesLoading(true));
  dispatch(setMetadataGroupsLoading(true));

  return Promise.all([
    [APIgetPageTaxonomies, getTaxonomies, setTaxonomiesLoading],
    [APIgetPageMetadataGroups, getMetadataGroups, setMetadataGroupsLoading],
    [APIgetPageStatuses, getFileStatuses],
  ].map(([fetchMetadata, receiveMetadata, setLoading]) => (
    fetchMetadata(pageId, options)
      .then(({ data }) => {
        if (!options.signal?.aborted) dispatch(receiveMetadata(data));
      })
      .catch(error => error)
      .finally(() => {
        if (setLoading && !options.signal?.aborted) dispatch(setLoading(false));
      })
  )));
};
